<template>
  <div>TrangSuaNhomChucVu</div>
</template>

<script>
export default {
  name: "TrangSuaNhomChucVu"
};
</script>


